import { ApiManager } from 'utlis/api_manager';
import http from 'utlis/http';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);

const designAuditApi = process.env.REACT_APP_DESIGN_AUDIT_BASE_URL;

export default class TeamDashboardReviews {
  static async submitReview(params = {}) {
    if (params.formData instanceof FormData) {
      return http.post(`${designAuditApi}/generate_review`, params.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-BACKEND-URL': process.env.REACT_APP_X_BACKEND_URL,
        },
      });
    }
  }
}

export const getSingleDesignReview = async reviewUuid => {
  const url = `project/team/design-reviews/${reviewUuid}`;

  try {
    const { data } = await api.setUrl(url).get();

    return data;
  }
  catch (e) {
    console.error(e);

    throw e;
  }
};

export const getDesignReviewShareLink = async (reviewUuid, signal = null) => {
  if (!reviewUuid) {
    throw new Error('reviewUuid is required to fetch design review share link');
  }

  const url = `project/team/design-reviews/${reviewUuid}/share-link`;
  const config = signal ? { signal } : {};
  const { data } = await api.setUrl(url).get(undefined, config);

  return data;
};

export const generateDesignReviewShareLink = async (reviewUuid, scope = 'domain') => {
  if (!reviewUuid) {
    throw new Error('reviewUuid is required to generate design review share link');
  }

  const validScope = scope === 'public' || scope === 'domain' ? scope : 'domain';
  const url = `project/team/design-reviews/${reviewUuid}/share-link`;
  const { data } = await api.setUrl(url).post({ scope: validScope });

  return data;
};

export const updateDesignReviewShareLinkScope = async (reviewUuid, scope) => {
  if (!reviewUuid) {
    throw new Error('reviewUuid is required to update design review share link scope');
  }

  const url = `project/team/design-reviews/${reviewUuid}/share-link`;
  const { data } = await api.setUrl(url).patch(null, { scope });

  return data;
};

export const getDesignReviewJobStatus = async jobId => {
  if (!jobId) {
    throw new Error('jobId is required to fetch design review status');
  }

  const url = `user/reviewer/design_review/${jobId}`;

  try {
    const { data } = await api.setUrl(url).get();

    return data;
  }
  catch (error) {
    console.error('Error fetching design review job status:', error);

    throw error;
  }
};

export const getSharedDesignReviewByToken = async (token, signal = null) => {
  if (!token) {
    throw new Error('Share token is required');
  }

  const url = `project/public/share/${token}`;
  const config = signal ? { signal } : {};
  const { data } = await api.setUrl(url).get(undefined, config);

  return data;
};

export const triggerDesignRemix = async ({
  imageUrl,
  insightUuid,
  deeperInsightText,
  figmaUserId,
  designReviewUuid,
}) => {
  const payload = {
    image_url: imageUrl,
    insight_uuid: insightUuid,
    deeper_insight_text: deeperInsightText,
    figma_user_id: figmaUserId,
    design_review_uuid: designReviewUuid,
  };

  return http.post(
    `${designAuditApi}/generate_design_remix`,
    payload,
    {
      headers: {
        'X-BACKEND-URL': process.env.REACT_APP_X_BACKEND_URL,
      },
    }
  ).then(({ data }) => data);
};

export const refineDesignRemix = async ({
  designReviewUuid,
  insightUuid,
  refinementPrompt,
  htmlUrl,
  imageUrl,
  parentProcessUuid,
  version,
  insightText,
  figmaUserId,
}) => {
  if (!designReviewUuid || !insightUuid) {
    throw new Error('designReviewUuid and insightUuid are required to refine design remix');
  }

  const payload = {
    design_review_uuid: designReviewUuid,
    insight_uuid: insightUuid,
    refinement_prompt: refinementPrompt,
    html_url: htmlUrl,
    image_url: imageUrl,
    parent_process_uuid: parentProcessUuid,
    version,
    insight_text: insightText,
    figma_user_id: figmaUserId,
  };

  return http.post(
    `${designAuditApi}/refine_design_remix`,
    payload,
    {
      headers: {
        'X-BACKEND-URL': process.env.REACT_APP_X_BACKEND_URL,
      },
    }
  ).then(({ data }) => data);
};

export const getDesignReviewPostProcess = async processUuid => {
  if (!processUuid) {
    throw new Error('processUuid is required to fetch design review post process');
  }

  const url = `project/design-review-post-processes/${processUuid}`;

  const { data } = await api.setUrl(url).get();

  return data;
};
